import React from 'react';
import EditorV3, { EditorProps } from 'Components/Editor/EditorV3';
import { FieldConfig } from 'formik';
import { Box, FormError, BoxProps } from 'pounceV2';
import useFastField from 'Hooks/useFastField';
import { safeguardErrorMsg } from '../utils';

const FormikEditorV3: React.FC<
  EditorProps & Required<Pick<FieldConfig, 'name'>> & Pick<BoxProps, 'sx'>
> = props => {
  const [, meta, { setValue }] = useFastField(props.name);

  const isInvalid = meta.touched && !!meta.error;
  const errorElementId = isInvalid ? `${props.name}-error` : undefined;

  return (
    <Box
      sx={{
        '.react-monaco-editor-container': {
          borderRadius: '6px',
          '.monaco-editor': {
            borderRadius: '6px',
            '.overflow-guard': {
              borderRadius: '6px',
            },
          },
        },
        ...props.sx,
      }}
    >
      <EditorV3
        {...props}
        aria-describedby={isInvalid ? errorElementId : undefined}
        onChange={value => setValue(value)}
      />
      {isInvalid && (
        <FormError mt={2} id={errorElementId}>
          {safeguardErrorMsg(meta.error)}
        </FormError>
      )}
    </Box>
  );
};

export default FormikEditorV3;
